'use client';

import { useMemo, useState } from 'react';
import ConcernsCarouselClient from './ConcernsCarousel/ConcernsCarouselClient';
import RecommendedTreatmentsClient from './RecommendedTreatments/RecommendedTreatmentsClient';
import {
  WhatIsYourConcern,
  Treatment,
} from '@/types/components/whatIsYourConcern';

type Props = {
  data: WhatIsYourConcern;
  concernOverlayClassName?: string;
};

const ConcernAndTreatmentsSection = ({
  data,
  concernOverlayClassName,
}: Props) => {
  // Get the cards (concerns) from the new structure
  const concerns = useMemo(() => data?.cards || [], [data]);

  // Set initial state based on first concern card
  const [selectedConcernHeading, setSelectedConcernHeading] = useState<
    string | undefined
  >(concerns[0]?.heading?.content);

  const [selectedTreatments, setSelectedTreatments] = useState<Treatment[]>(
    concerns[0]?.treatments ?? [],
  );

  if (!concerns.length) return null;

  const handleConcernChange = (
    concernHeading: string | undefined,
    treatments: Treatment[],
  ) => {
    setSelectedConcernHeading(concernHeading);
    setSelectedTreatments(treatments);
  };

  return (
    <section
      id="pharmacists-advices-and-treatment"
      data-testid="content-wrapper"
      className="relative mt-8 overflow-x-hidden md:mt-10"
    >
      <span id="pharmacist-advices" className="absolute -top-28" />
      <span
        id="pharmacist-advices-and-treatment"
        className="absolute -top-28"
      />
      <ConcernsCarouselClient
        data={data}
        concerns={concerns}
        onConcernChange={({ concernHeading, treatments }) => {
          handleConcernChange(concernHeading, treatments);
        }}
        concernOverlayClassName={concernOverlayClassName}
      />

      <RecommendedTreatmentsClient
        concernTitle={selectedConcernHeading}
        treatments={selectedTreatments}
      />
    </section>
  );
};

export default ConcernAndTreatmentsSection;
